import { useEffect } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { LINKS } from '../config/links'
import './GetAppModal.css'

type GetAppModalProps = {
  open: boolean
  onClose: () => void
}

export function GetAppModal({ open, onClose }: GetAppModalProps) {
  useEffect(() => {
    if (!open) return
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = prev
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="get-app-modal" role="dialog" aria-modal="true" aria-labelledby="get-app-title">
      <button
        type="button"
        className="get-app-modal__backdrop"
        aria-label="Close"
        onClick={onClose}
      />
      <div className="get-app-modal__panel">
        <button type="button" className="get-app-modal__close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <h2 id="get-app-title">Get the app</h2>
        <p className="get-app-modal__copy">
          Scan to download Music24 on your phone.
        </p>
        <div className="get-app-modal__qr">
          <QRCodeSVG
            value={LINKS.downloadApp}
            size={180}
            bgColor="#ffffff"
            fgColor="#050505"
            level="M"
            marginSize={1}
          />
        </div>
        <a className="get-app-modal__link" href={LINKS.downloadApp}>
          Or open download link
        </a>
      </div>
    </div>
  )
}
